import { render } from "./LegalDocumentPage.vue?vue&type=template&id=720fd27c&scoped=true"
import script from "./LegalDocumentPage.vue?vue&type=script&lang=js"
export * from "./LegalDocumentPage.vue?vue&type=script&lang=js"

import "./LegalDocumentPage.vue?vue&type=style&index=0&id=720fd27c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720fd27c"]])

export default __exports__